var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBranchlogo2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 69,
    viewBox: "0 0 137 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3935_168105)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.998123 68.8301H50.6581L88.9881 30.5001L123.748 30.5001C124.228 33.5201 126.838 35.8301 129.998 35.8301C133.498 35.8301 136.328 32.9901 136.328 29.5001C136.328 26.0101 133.488 23.1701 129.998 23.1701C126.838 23.1701 124.228 25.4801 123.748 28.5001L103.738 28.5001L75.2381 7.62939e-05H35.8281C35.2781 7.62939e-05 34.8281 0.450073 34.8281 1.00008C34.8281 1.55008 35.2781 2.00008 35.8281 2.00008H74.4181L100.918 28.5001L15.4981 28.5001C14.9481 28.5001 14.4981 28.9501 14.4981 29.5001C14.4981 30.0501 14.9481 30.5001 15.4981 30.5001L86.1581 30.5001L49.8281 66.8301H0.988129C0.438126 66.8301 -0.0118713 67.2801 -0.0118713 67.8301C-0.0118713 68.3801 0.438126 68.8301 0.988129 68.8301H0.998123Z",
    fill: "#C6CECE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.328 29.5001C136.328 32.9901 133.498 35.8301 129.998 35.8301C126.498 35.8301 123.668 33.0001 123.668 29.5001C123.668 26.0001 126.498 23.1701 129.998 23.1701C133.498 23.1701 136.328 26.0101 136.328 29.5001Z",
    fill: "#F4F4FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3935_168105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136.33,
    height: 68.83,
    fill: "white",
    transform: "matrix(-1 0 0 -1 136.328 68.8301)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranchlogo2);
export default __webpack_public_path__ + "static/media/branchlogo2.84e730bbc3f222128972b50a07507469.svg";
export { ForwardRef as ReactComponent };